import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Chip, Divider } from "@mui/material";
import { useState } from "react";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { faintblue, faintGray } from "../../../theme/palette";
import { reasonListGetAPI, upsertHexFileAlertAPI } from "./apiAndKeys/apiCalls";
import { HexFileKeys } from "./apiAndKeys/entity";
var HexFileAccordion = function (props) {
    var AlertDetailId = props.AlertDetailId;
    var _a = useState(false), isSkipSelected = _a[0], setIsSkipSelected = _a[1];
    var reasonList = function (params) { return reasonListGetAPI(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread(_objectSpread({}, params.request), {}, {
            SystemName: HexFileKeys.systemName,
            Type: 6
        })
    })); };
    var listElements = [{
            type: FormItemTypes.CardComponent,
            name: '',
            label: undefined,
            value: null,
            md: 12,
            sx: {
                bgcolor: faintblue,
                borderRadius: 2,
                borderColor: faintGray
            },
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'ecu_name',
                    label: 'ECU type :',
                    value: null,
                    columnSize: 12,
                    containerProps: {
                        container: true,
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    },
                    labelTypographyProps: {
                        variant: 'h6',
                        mb: 0
                    },
                    variant: 'h6'
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    label: 'Hex file :',
                    value: 'Update required',
                    columnSize: 12,
                    containerProps: {
                        container: true,
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    },
                    labelTypographyProps: {
                        variant: 'h6',
                        mb: 0
                    },
                    variant: 'h6'
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    alignItems: "center",
                    justifyContent: 'space-between',
                    elements: [{
                            type: FormItemTypes.Custom,
                            name: '',
                            label: '',
                            value: null,
                            columnSize: 0,
                            element: function () { /*#__PURE__*/ return React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Chip, {
                                label: "Pending",
                                size: "small",
                                variant: "outlined",
                                color: "error",
                                sx: {
                                    borderRadius: 2,
                                    px: 1,
                                    typography: 'h6',
                                    color: 'info'
                                }
                            })); }
                        }, {
                            type: FormItemTypes.Attachment,
                            name: "Attachments",
                            label: "",
                            placeholder: "Upload Files",
                            value: null,
                            columnSize: 6,
                            inputProps: {
                                accept: "application/*",
                                multiple: true
                            },
                            containerProps: {
                                flexWrap: 'nowrap',
                                flexShrink: 0
                            }
                        }]
                }]
        }];
    var data = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            padding: 1,
            elements: [{
                    type: FormItemTypes.List,
                    name: 'ChildAssociations',
                    columnSize: 12,
                    value: null,
                    disableCheckboxSelection: true,
                    disableDetailsPanel: true,
                    variant: 'comfortable',
                    getRowHeight: function () { return "auto"; },
                    getRowId: function (row) { return row === null || row === void 0 ? void 0 : row['ecu_name']; },
                    columns: [{
                            field: '',
                            flex: 1,
                            renderCell: function () { /*#__PURE__*/ return React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
                                formData: listElements,
                                createFormAPI: upsertHexFileAlertAPI,
                                createKey: HexFileKeys.upsertHexFileAlert
                            })); }
                        }]
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    label: '',
                    value: null,
                    children: /*#__PURE__*/ React.createElement(Divider, null),
                    columnSize: 12
                }, {
                    type: FormItemTypes.CheckBox,
                    name: 'skip',
                    label: 'Skip for now',
                    value: null,
                    columnSize: 12,
                    onChange: function (e, value) {
                        setIsSkipSelected(value);
                    },
                    formControlLabelProps: {
                        slotProps: {
                            typography: {
                                variant: 'h6'
                            }
                        }
                    }
                }, isSkipSelected ? {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    elements: [{
                            type: FormItemTypes.SearchSelect,
                            name: 'Reason',
                            label: 'Reason',
                            value: null,
                            getListData: reasonList,
                            columnSize: 12
                        }, {
                            type: FormItemTypes.TextInput,
                            name: "Remark",
                            label: "Remark",
                            value: null,
                            columnSize: 12,
                            multiline: true,
                            maxLength: 200,
                            minRows: 3
                        }],
                    columnSize: 12
                } : null, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    alignItems: "center",
                    justifyContent: "flex-end",
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "save",
                            label: "",
                            value: null,
                            children: 'Save',
                            columnSize: 0,
                            variant: "contained",
                            onClick: function () { return "submit"; }
                        }]
                }]
        }];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: data,
        mode: "edit",
        gridSpacing: 0,
        formProps: {
            bgcolor: faintblue
        }
    });
};
export default HexFileAccordion;
